export function getLineTotals ( lineItems ) {
    return lineItems.reduce( ( acc, next ) => {
        acc += next.price * (next.quantity || 1);
        return acc;
    }, 0 );
}